import { FC, ReactNode } from 'react'

import Styles from './Layout.module.scss'

interface Props {
    children: ReactNode
}
export const Layout: FC<Props> = ({ children }) => {
    return <div className={Styles.seasonDetail}>{children}</div>
}
